import { ECurrentSortVariantType } from '../../repositories/newbuilding-promos/entities/search_promos/SearchPromosResponseSchema';
import {
  EKey,
  ISortVariantSchema,
} from '../../repositories/newbuilding-promos/entities/sort_variant/SortVariantSchema';

export const getCurrentSortVariantTypeMk = (): ECurrentSortVariantType => {
  return ECurrentSortVariantType.Popularity;
};

export const getSortVariantsMk = (): ISortVariantSchema[] => {
  return [
    {
      key: EKey.Popularity,
      value: 'По популярности',
    },
    {
      key: EKey.NewFirst,
      value: 'Сначала новые',
    },
    {
      key: EKey.AboutToEnd,
      value: 'Заканчивается период действия',
    },
  ];
};
